<div class="auto-form">
  <fieldset class="mbl">
    <div class="row">
      <div class="col-xs-12">
        <div class="btn-group mbm">
          @if (mainAddress.situation != 'OWNER') {
            <span class="btn btn-default btn-xs pan"> </span>
          }

          @if (mainAddress.situation == 'OWNER') {
            <span class="btn btn-info btn-xs text-uppercase">
              {{ 'pages.realEstate.owner' | translate }}
            </span>
          }

          @if (mainAddress.situation != 'TENANT') {
            <span class="btn btn-default btn-xs pan"> </span>
          }

          @if (mainAddress.situation == 'TENANT') {
            <span class="btn btn-info btn-xs text-uppercase">
              {{ 'pages.realEstate.tenant' | translate }}
            </span>
          }

          @if (mainAddress.situation != 'HOSTED') {
            <span class="btn btn-default btn-xs pan"> </span>
          }

          @if (mainAddress.situation == 'HOSTED') {
            <span class="btn btn-info btn-xs text-uppercase">
              {{ 'pages.realEstate.hosted' | translate }}
            </span>
          }
        </div>
      </div>
    </div>

    @if (mainAddress.situation != 'OWNER') {
      <div class="row">
        <div class="col-xs-6 col-sm-4">
          <label>{{ 'pages.realEstate.rents' | translate }} (€)</label>
          <input
            name="amount"
            min="0"
            value="{{ rent?.amount }}"
            type="number"
            (blur)="onUpdateExpense($event)"
            class="form-control"
            [readonly]="mainAddress.situation == 'HOSTED'"
          />
        </div>
        <div class="col-xs-6 col-sm-4">
          <label
            >{{ 'pages.realEstate.surface' | translate }} (m<sup>2</sup>)</label
          >
          <input
            name="propertyAreaSize"
            min="0"
            value="{{ mainAddress.propertyAreaSize }}"
            type="number"
            (blur)="onAddressChange($event)"
            class="form-control"
          />
        </div>
        <div class="col-xs-6 col-sm-4">
          <label>{{ 'pages.realEstate.head.title16' | translate }}</label>
          <select
            name="propertyType"
            class="form-control"
            (change)="onAddressChange($event)"
          >
            <option
              value="APPARTMENT"
              [selected]="mainAddress.propertyType == 'APPARTMENT'"
            >
              {{ 'pages.realEstate.appartment' | translate }}
            </option>
            <option
              value="HOUSE"
              [selected]="mainAddress.propertyType == 'HOUSE'"
            >
              {{ 'pages.realEstate.house' | translate }}
            </option>
          </select>
        </div>
      </div>
    }

    @if (mainAddress.situation == 'OWNER') {
      <div class="form-inline">
        <div class="form-group">
          <label class="bold">
            <input
              type="checkbox"
              name="isRp"
              [checked]="isRp"
              class="isrp"
              (click)="onIsRpChange($event)"
            />
            Même adresse de ma résidence principale
          </label>
        </div>
      </div>
    }
  </fieldset>

  <fieldset class="fieldset-diviser" [disabled]="isRp">
    <div class="row">
      <div class="col-sm-6">
        <label>{{ 'pages.profile.address' | translate }}</label>
        <input
          type="text"
          name="street"
          #searchInput
          value="{{ mainAddress.street }}"
          class="form-control"
          (blur)="onAddressChange($event)"
          autocomplete="off"
        />
      </div>

      <div class="col-sm-6 form-group">
        <label>{{ 'pages.profile.zipCode' | translate }}</label>
        <input
          type="text"
          name="zipCode"
          value="{{ mainAddress.zipCode }}"
          class="form-control"
          (blur)="onAddressChange($event)"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 form-group">
        <label>{{ 'pages.profile.city' | translate }}</label>
        <input
          type="text"
          name="city"
          value="{{ mainAddress.city }}"
          class="form-control"
          (blur)="onAddressChange($event)"
          autocomplete="off"
        />
      </div>
      <div class="col-sm-6 form-group">
        <label>{{ 'pages.profile.country' | translate }}</label>
        <select
          name="country"
          value="{{ mainAddress.country }}"
          class="form-control"
          (change)="onAddressChange($event)"
        >
          <option>-- {{ 'pages.profile.chooseCountry' | translate }} --</option>
          @for (item of countries; track item) {
            <option
              value="{{ item.id }}"
              [selected]="mainAddress.country == item.id"
            >
              {{ item.value }}
            </option>
          }
        </select>
      </div>
    </div>
  </fieldset>
</div>
